import merge from 'lodash/merge';
import action from './action.js';
import enActivity from './activity.js';
import core from './core.js';
import error from './error.js';
import login from './login.js';

var en = {
  language: 'en',
  country: 'gb',
  name: 'English',
  embeddedLocale: merge(action, enActivity, core, error, login),
  flags: ['GB', 'US'],
};

export { en as default };
